import { useState, useEffect } from 'react';

/**
 * Custom hook for NexusFilterDropdown component logic
 *
 * @param {Object} props - Hook props
 * @param {Array} props.options - Array of option objects with value and label
 * @param {Array} props.value - Array of selected values (controlled)
 * @param {Array} props.initialValue - Initial selected values
 * @param {Function} props.onChange - Custom onChange handler
 * @param {boolean} props.disabled - Whether the dropdown is disabled
 */
export function useMultiSelectionFilterDropdown({
  options = [],
  value,
  initialValue = [],
  onChange,
  disabled = false,
  ref,
}) {
  const [selectedValues, setSelectedValues] = useState(
    value || initialValue || []
  );

  // Update selectedValues when value prop changes
  useEffect(() => {
    if (value !== undefined) {
      setSelectedValues(value);
    }
  }, [value]);

  const handleSelectionChange = (event, newValue) => {
    // newValue will be an array for multiple selection
    const newSelectedValues = newValue || [];

    setSelectedValues(newSelectedValues);

    if (onChange) {
      onChange(newSelectedValues);
    }
  };

  const getDisplayText = label => {
    if (selectedValues.length === 0) {
      return label;
    }

    if (selectedValues.length === 1) {
      // Single selection - show the label
      const selectedValue = selectedValues[0];
      const option = options.find(opt => opt.value === selectedValue);
      return option ? option.label : selectedValue;
    }

    // Multiple selections - show count
    return `${selectedValues.length} selected`;
  };

  const hasSelection = selectedValues.length > 0;

  return {
    // State
    selectedValues,
    hasSelection,

    // Functions
    handleSelectionChange,
    getDisplayText,
  };
}
